import { useEffect, useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import { useCorporateBondScreenerSidebarFilterContext } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import mapToCheckboxOptions from '@/creditflowresearch/application/BondScreener/mapToCheckboxOptions';

const useRegistrationsSection = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const repository = getContainer().get(DictionaryRepository);
  const [dictionary, setDictionary] = useState([]);

  useEffect(() => {
    const loadDictionary = async () => {
      setDictionary(await repository.getRegistrationGroups());
    };
    loadDictionary();
  }, []);

  const items = useMemo(
    () => mapToCheckboxOptions(filters?.registrationGroupIds, dictionary),
  [dictionary, filters?.registrationGroupIds]);

  return useCheckboxFilter({ filterKey: 'includedRegistrationGroupIds', items });
};

export default useRegistrationsSection;
